import { BrandController } from './brand.controller'
import { SearchResultController } from './pages/search-result/search-result.controller'

const checkModuleEnabled = [
  '$state',
  '$q',
  '$rootScope',
  ($state, $q, $rootScope) => {
    const deferred = $q.defer()

    $rootScope.getCompanyConfigurations()
      .then(configs => {
        $rootScope.getCompanyFeaturesAndAddons().then(function ({ features }) {
          const shouldShowModule = features['ARTS.ACCESS'] || (!features['ARTS.ACCESS'] && features['BRAND.ACCESS'])
          if ($rootScope.isUser()) {
            if (shouldShowModule && configs.ENABLE_BRAND_ASSETS_MODULE_USER) {
              deferred.resolve()
            } else {
              deferred.reject()
            }
          } else if (shouldShowModule) {
            deferred.resolve()
          } else {
            deferred.reject()
          }
        })
      })

    return deferred.promise
      .catch(() => {
        $state.go('home')
      })
  }
]

/* @ngInject */
function routes ($stateProvider, $urlRouterProvider) {
  $stateProvider
    .state('brand', {
      url: '/brand?previewId',
      resolve: {
        checkModuleEnabled
      },
      views: {
        '': {
          templateUrl: '/brand/brand.html?$$REVISION$$',
          controller: BrandController
        },
        'secondLevelMenu@brand': {
          templateUrl: '/brand/brand-sidebar-menu.html?$$REVISION$$'
        },
        'searchResult@brand': {
          templateUrl: '/brand/pages/search-result/search-result.html?$$REVISION$$',
          controller: SearchResultController
        }
      },
      reloadOnSearch: false
    })

  $urlRouterProvider.when('/brand/', '/brand')
}

export const brandRoutes = routes
